<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/partnerCurrentList' }">合作往来</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <!-- <el-button size="small" plain @click="insert">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="update">编辑</el-button>
                    <el-button size="small" plain @click="del">删除</el-button> -->
                    <draggableDetail :draggable="{ data_name: 'partner_current' }" @isErrshow="reload"></draggableDetail>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''" :key="index">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="
                                                (item.prop == 'partner_name' && data['partner_rid'] != '') ||
                                                (item.prop == 'product_name' && data['product_rid'] != '')
                                            "
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="合作往来行" name="2">
                    <vPartnerCurrentLineComponent v-if="flag" :postList="line_withhold_list_params"></vPartnerCurrentLineComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="合作往来保留" name="3">
                    <vPartnerCurrentWithholdComponent v-if="flag" :postList="line_withhold_list_params"></vPartnerCurrentWithholdComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="合作往来核销" name="4">
                    <vPartnerCurrentDeductionComponent v-if="flag" :postList="deduction_list_params"></vPartnerCurrentDeductionComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, processColumnDataToRowNew } from '@/js/common';
import vPartnerCurrentLineComponent from '../../listComponent/basicdata/partnerCurrentLine/partnerCurrentLineComponent.vue';
import vPartnerCurrentWithholdComponent from '../../listComponent/basicdata/partnerCurrentWithhold/partnerCurrentWithholdComponent.vue';
import vPartnerCurrentDeductionComponent from '../../listComponent/basicdata/partnerCurrentDeduction/partnerCurrentDeductionComponent.vue';
import draggableDetail from '../../../common/DrawerDetail.vue';

export default {
    inject: ['reload'],
    name: 'partnerCurrentDetail',
    components: {
        vPartnerCurrentLineComponent,
        vPartnerCurrentWithholdComponent,
        vPartnerCurrentDeductionComponent,
        draggableDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2', '3', '4'],
            data: {},
            queryParams: {},
            headerTitle: '合作往来详情',
            flag: false, // 所有的明细列表公用一个flag
            line_withhold_list_params: {},
            deduction_list_params: {}
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.initListsParams();
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.initListsParams();
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
        });
    },
    methods: {
        initListsParams() {
            this.line_withhold_list_params.params = {
                partner_current_rid: this.queryParams.rid
            };
            this.line_withhold_list_params.downFileBtn = true;
            this.line_withhold_list_params.uploadBtn = true;
            this.line_withhold_list_params.addBtn = true;
            this.line_withhold_list_params.setBtn = true;

            this.deduction_list_params.params = {
                partner_current_rid: this.queryParams.rid
            };
            this.deduction_list_params.downFileBtn = true;
            this.deduction_list_params.setBtn = true;
        },
        toDetail(prop) {
            if (prop == 'partner_name' && this.data.partner_rid != '') {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: this.data.partner_rid
                    }
                });
            } else if (prop == 'product_name' && this.data.product_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.product_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).partner_current;
            processColumnDataToRowNew(colData, this);
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'partnerCurrentDelete', this.data.rid, 'partnerCurrentList');
        },
        //编辑
        update() {
            this.$router.push({
                path: 'partnerCurrentEdit',
                query: {
                    type: 'update',
                    id: this.data.rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'partnerCurrentEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'partnerCurrentEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid
                }
            });
        },
        //详情
        getData() {
            this.$api
                .partnerCurrentDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.rid;
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>